import { Entity } from "../../Entity";
import AddressFactory from "../../Factories/AddressFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { AddressInterface } from "./AddressInterface";

class Address extends Entity implements AddressInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return AddressFactory;
  }

  get id(): number {
    return this.data.id;
  }
}

export { Address };
